import { render } from "./MainContainer.vue?vue&type=template&id=5745cd32&scoped=true&ts=true"
import script from "./MainContainer.vue?vue&type=script&lang=ts"
export * from "./MainContainer.vue?vue&type=script&lang=ts"

import "./MainContainer.vue?vue&type=style&index=0&id=5745cd32&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5745cd32"]])

export default __exports__